import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  icon?: React.ReactNode;
  href?: string;
}
export function Button({
  children,
  onClick,
  className = '',
  icon,
  href
}: ButtonProps) {
  const sharedClass = `w-full sm:w-auto bg-[#2D5A27] text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-lg hover:bg-[#1e3d1a] transition-colors flex items-center justify-center gap-3 no-underline ${className}`;
  if (href) {
    return <motion.a whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.98
    }} href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} className={sharedClass} data-id="element-183">
        {children}
        {icon && <span data-id="element-184">{icon}</span>}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={sharedClass} data-id="element-185">
      {children}
      {icon && <span data-id="element-186">{icon}</span>}
    </motion.button>;
}